import {
    ComplianceEngineResultFragmentFragment,
    ComplianceProviderResultFragmentFragment
} from "../../../__generated__/graphql/types";
import {isTruey} from "../../../common/util-ts";

export function scanForProviders(complianceResult: ComplianceEngineResultFragmentFragment): ComplianceProviderResultFragmentFragment[] {
    if (!complianceResult) { return [] }

    return Object.keys(complianceResult)
        .map((key) => {
            if (key.match(/^\w+ProviderResult$/)) {
                return complianceResult[key];
            }
            return null;
        })
        .filter(isTruey);
}